<template>
    <!-- data app is needed for testing otherwise it will throw errors -->
    <div data-app="true" v-if="sessionActive">

        <v-container fluid v-if="sessionActive" class="pa-3">

            <v-card>

                <material-header help="user-management"
                                 title="User management"
                                 info="Showing all users"
                                 icon="mdi-shield-account">
                </material-header>

                <v-tabs class="pl-2" v-model="tab" color="white" slider-color="primary">
                    <v-tab>Users</v-tab>
                    <v-tab>Roles</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">

                    <!-- USERS TAB -->
                    <v-tab-item>
                        <users-tab></users-tab>
                    </v-tab-item>

                    <!-- ROLES TAB -->
                    <v-tab-item>
                        <roles-tab></roles-tab>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>

            <v-row>
                <v-col cols="12" v-if="!hasPermission('view users')">
                    <v-alert
                        class="body-2"
                        type="error"
                    >
                        Your user account doesn't have permission to access the user management
                    </v-alert>
                </v-col>

            </v-row>
        </v-container>

    </div>
</template>

<script>

import activeSessionChecker from '../../../components/mixins/activeSessionCheckerMixin';
import MaterialHeader from '../../../components/UI/MaterialHeader';
import RolesTab from "./RolesTab/RolesTab";
import UsersTab from "./UsersTab/UsersTab";
import {mapActions, mapState} from "vuex";

export default {

    mixins: [activeSessionChecker],

    components: {
        UsersTab,
        RolesTab,
        MaterialHeader,
    },

    data() {
        return {
            roleEditorUser: null,
            tab: null,
        }
    },

    methods: {

        ...mapActions('UserManager', [
            'getUsers',
            'getRoles',
        ]),

        loadData(force = false) {
            this.getUsers(force)
                .catch(() => {
                    Bus.$emit('server-error');
                })
            // Get all roles and permissions
            this.getRoles(force)
                .catch(() => {
                    Bus.$emit('server-error');
                })
        },
    },

    created() {
        if (this.hasPermission('view users')) {
            this.loadData();
        }
    },
}

</script>
